<template>
  <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
      <v-card max-height="600px">
			<v-toolbar flat color="primary white--text"><h1>Modulo</h1></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="12" class="col-sm-6">
                        <v-text-field dense label="Código" readonly v-model="modulo.id" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" class="col-sm-6">
                        <v-text-field dense label="Nome" v-model="modulo.nome" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="modulo.id > 0">
                    <v-col>
                        <Aulas :idModulo="modulo.id" :aulas="modulo.aulas" @atualizaAulas="atualizaAulas($event)"  @excluirAula="retirarAulaExcluida($event)"/>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
  </v-dialog>   
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showSuccess, showError } from "@/config/global"
import Aulas from '@/components/admin/cursos/Aulas'

export default {
    name: 'Modulo',
    props:['mostrar', 'idCurso', 'moduloEdicao'],
    components:{Aulas},
    data(){
        return{
            modulo:{
                id: 0,
                aulas: []
                
            }
        }
    },
    methods:{
        fechar(){
            this.modulo = {id: 0}
            this.$emit('fecharModulo')
        },

        atualizaAulas(aula){
            
            let idx = this.modulo.aulas.findIndex(v => {
                return v.id == aula.id
            })

            if(idx >= 0){
                this.modulo.aulas[idx] = aula
            }else{
                this.modulo.aulas.push(aula)
            }
            
        },

        salvar(){
            if(this.modulo.id == 0){
                const url = `${baseApiUrl}/Cursos/insertModulo.php`
                this.modulo.id_curso = this.idCurso

                axios.post(url, this.modulo)
                .then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        this.modulo.id = res.data.id
                        this.$emit('moduloCadastrado', this.modulo)
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }else{
                const url = `${baseApiUrl}/Cursos/updateModulo.php`
                this.modulo.id_curso = this.idCurso

                axios.post(url, this.modulo)
                .then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        this.$emit('moduloAtualizado', this.modulo)
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            }
        },

        retirarTopicoExcluida(id){
            let idx = this.modulo.topicos.findIndex(v => {
                return v.id == id
            })

            this.modulo.topicos.splice(idx, 1)
        }
    },
    watch:{
        mostrar(v){
            if(v){
                if(this.moduloEdicao.id){
                    this.modulo = this.moduloEdicao
                    if(this.modulo.topicos == undefined){
                        this.modulo.topicos = []
                    }
                    
                }else{
                    if(this.modulo.topicos == undefined){
                        this.modulo.topicos = []
                    }
                    
                }
                
            }
        }
    },
}
</script>

<style scoped>

</style>